/* unplugin-vue-components disabled */import __unplugin_components_4 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-button.vue';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import __unplugin_components_2 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-form-item.vue';
import __unplugin_components_1 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-input.vue';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page-login"
};
const _hoisted_2 = {
  key: 0,
  class: "logo"
};
const _hoisted_3 = {
  key: 1,
  class: "to-continue-to"
};
const _hoisted_4 = {
  class: "oauth-box"
};
const _hoisted_5 = {
  key: 2,
  class: "or-box"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1);

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1);

const _hoisted_8 = {
  key: 4
};
const _hoisted_9 = {
  key: 6,
  class: "other"
};
const _hoisted_10 = {
  class: "login-sign-protocol"
};
const _hoisted_11 = {
  target: "_blank",
  href: "https://cdn.cassava.network/public/Cassava_TC_AC-220927-dark.html"
};
const _hoisted_12 = {
  target: "_blank",
  href: "https://cdn.cassava.network/public/Cassava_Technologies_Limited_Privacy_Policy-dark.html"
};
import { useOAuthLoginStore } from '@/store/oauth-login';
import { upGA, useUniPass, formatEmail } from '@/utils/useUniPass';
import { OAuthProvider } from '@/service/enum';
import { isIframeEnv } from '@/service/check-environment';
import { useIndexPageStyle } from '@/composable/useIndex';
import { LocalStorageService } from '@/store/storages';
import { getOpenType } from '@/service/check-environment';
import { useUserStore } from '@/store/user';
import { reportDeheroEvent } from '@/service/third-parity-backend';
export default /*#__PURE__*/_defineComponent({
  __name: 'page-login',

  setup(__props) {
    const formElement = ref();
    const emailElement = ref();
    const route = useRoute();
    const hasFocused = ref(false);

    if (route.query.source && route.query.source === 'ethdenver') {
      var _sessionStorage;

      (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.setItem('up_login_source', 'ethdenver');
    }

    const unipass = useUniPass();
    const oauthStore = useOAuthLoginStore();
    const pageStyle = useIndexPageStyle();
    const userStore = useUserStore();
    const isLogin = computed(() => {
      return route.path === '/login' && !pageStyle.isDeheroEnv.value;
    });
    onBeforeMount(() => {
      const connectType = sessionStorage.connectType;

      if (connectType) {
        oauthStore.connectType = connectType;
      }
    });

    const submit = () => {
      if (isLogin.value) {
        login();
      } else {
        register();
      }
    };

    const google = () => {
      if (isLogin.value) {
        upGA('login_click_google');
      } else {
        upGA('register_click_google');
      }

      oauthStore.loginWithGoogle();
    };

    const apple = () => {
      if (isLogin.value) {
        upGA('login_click_apple');
      } else {
        upGA('register_click_apple');
      }

      oauthStore.auth0Login({
        provider: OAuthProvider.APPLE
      });
    };

    const login = () => {
      if (!oauthStore.email) {
        var _emailElement$value, _emailElement$value$e;

        (_emailElement$value = emailElement.value) === null || _emailElement$value === void 0 ? void 0 : (_emailElement$value$e = _emailElement$value.element) === null || _emailElement$value$e === void 0 ? void 0 : _emailElement$value$e.focus();
        return;
      }

      if (!formElement.value) return;
      formElement.value.validate(ok => {
        if (ok) {
          upGA('login_click_continue', {
            email: oauthStore.email
          }, 1);
          oauthStore.auth0Login({
            provider: OAuthProvider.AUTH0
          });
        }
      });
    };

    const register = () => {
      if (!oauthStore.email) {
        var _emailElement$value2, _emailElement$value2$;

        (_emailElement$value2 = emailElement.value) === null || _emailElement$value2 === void 0 ? void 0 : (_emailElement$value2$ = _emailElement$value2.element) === null || _emailElement$value2$ === void 0 ? void 0 : _emailElement$value2$.focus();
        return;
      }

      if (!formElement.value) return;
      formElement.value.validate(ok => {
        if (ok) {
          upGA('register_click_continue', {
            email: oauthStore.email
          }, 1);
          oauthStore.auth0Login({
            provider: OAuthProvider.AUTH0
          });
        }
      });
    };

    const isNotMufex = () => {
      return (userStore.theme || sessionStorage.theme) !== 'mufex';
    };

    const appName = computed(() => {
      return getOpenType() !== 'origin' && isNotMufex() && LocalStorageService.get('UP_CONNECT_SOURCE');
    });
    const showGoogle = computed(() => {
      return (oauthStore.connectType === 'google' || oauthStore.connectType === 'both') && !isIframeEnv();
    });
    const showApple = computed(() => {
      return (oauthStore.connectType === 'apple' || oauthStore.connectType === 'both') && !isIframeEnv();
    });
    const showDivider = computed(() => {
      return oauthStore.connectType === 'both' && !isIframeEnv();
    });
    const showEmail = computed(() => {
      return oauthStore.connectType === 'email' || oauthStore.connectType === 'both' || isIframeEnv();
    });
    const theme = computed(() => {
      return userStore.theme || sessionStorage.theme;
    });

    const onEmailInput = v => {
      if (!hasFocused.value) {
        hasFocused.value = true;
        reportDeheroEvent('begin_typing_email');
      }

      oauthStore.email = formatEmail(v);
    };

    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      const _component_up_input = __unplugin_components_1;

      const _component_up_form_item = __unplugin_components_2;

      const _component_el_form = __unplugin_components_3;

      const _component_up_button = __unplugin_components_4;

      const _component_router_link = _resolveComponent("router-link");

      const _component_i18n_t = _resolveComponent("i18n-t");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(pageStyle).isDeheroEnv.value ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("h1", null, _toDisplayString(_unref(isLogin) ? _ctx.$t('LoginTitle') : _ctx.$t('RegisterTitle')), 1), _unref(appName) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.$t('ToContinueTo')) + " ", 1), _createElementVNode("span", null, _toDisplayString(_unref(appName)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_unref(showGoogle) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "one google",
        onClick: google
      }, [_createVNode(_component_up_icon, {
        name: "google"
      }), _createElementVNode("span", null, _toDisplayString(_unref(isLogin) ? _ctx.$t('LoginWithGoogle') : _ctx.$t('SignUpWithGoogle')), 1)])) : _createCommentVNode("", true), _unref(showApple) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "one apple",
        onClick: apple
      }, [_createVNode(_component_up_icon, {
        name: "apple"
      }), _createElementVNode("span", null, _toDisplayString(_unref(isLogin) ? _ctx.$t('LoginWithApple') : _ctx.$t('SignUpWithApple')), 1)])) : _createCommentVNode("", true)]), _unref(showDivider) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(_unref(isLogin) ? _ctx.$t('OrEmailLogin') : _ctx.$t('OrEmailRegister')), 1), _hoisted_7])) : _createCommentVNode("", true), _unref(showEmail) ? (_openBlock(), _createBlock(_component_el_form, {
        key: 3,
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        ref_key: "formElement",
        ref: formElement,
        model: _unref(oauthStore)
      }, {
        default: _withCtx(() => [_createVNode(_component_up_form_item, {
          label: _unref(oauthStore).email && _ctx.$t('Email'),
          prop: "email",
          type: "email",
          rules: [{
            validator: _unref(unipass).checkEmailFormat,
            trigger: 'blur'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_up_input, {
            ref_key: "emailElement",
            ref: emailElement,
            placeholder: _ctx.$t('EmailEmpty'),
            onInput: onEmailInput,
            onFocus: _cache[0] || (_cache[0] = $event => {
              var _formElement$value;

              return (_formElement$value = formElement.value) === null || _formElement$value === void 0 ? void 0 : _formElement$value.clearValidate('email');
            }),
            modelValue: _unref(oauthStore).email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(oauthStore).email = $event),
            clearable: "",
            onKeydown: _cache[2] || (_cache[2] = _withKeys($event => _unref(oauthStore).email && login(), ["enter"])),
            autofocus: ""
          }, null, 8, ["placeholder", "modelValue"])]),
          _: 1
        }, 8, ["label", "rules"])]),
        _: 1
      }, 8, ["model"])) : _createCommentVNode("", true), !_unref(isLogin) && _unref(theme) === 'metacene' ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_ctx.$t('RegisterTipMetacene')), 1)) : _createCommentVNode("", true), _unref(showEmail) ? (_openBlock(), _createBlock(_component_up_button, {
        key: 5,
        class: "submit",
        type: "primary",
        onClick: submit,
        loading: _unref(oauthStore).auth0EmailLoading
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(isLogin) ? _ctx.$t('Login') : _ctx.$t('Continue')), 1)]),
        _: 1
      }, 8, ["loading"])) : _createCommentVNode("", true), !_unref(pageStyle).isDeheroEnv.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createTextVNode(_toDisplayString(_unref(isLogin) ? _ctx.$t('NoAccount') : _ctx.$t('HaveAccount')) + " ", 1), _createVNode(_component_router_link, {
        replace: "",
        to: _unref(isLogin) ? '/register' : '/login',
        class: "underline"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(isLogin) ? _ctx.$t('ToSignUp') : _ctx.$t('Login')), 1)]),
        _: 1
      }, 8, ["to"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createVNode(_component_i18n_t, {
        keypath: "Protocol",
        tag: false
      }, {
        terms: _withCtx(() => [_createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.$t('Terms')), 1)]),
        privacy: _withCtx(() => [_createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('Privacy')), 1)]),
        _: 1
      })])]);
    };
  }

});